import { translateValidationObject } from '../translate';

class ValidationError {
  protected errorsPromise: Promise<any>;
  constructor(res) {
    // super('Validation Error');

    this.errorsPromise = res.json();
  }

  getMessages() {
    return this.errorsPromise;
  }

  getTranslatedMessages() {
    return this.getMessages()
      .then(translateValidationObject)
  }
}

export default ValidationError;



// WEBPACK FOOTER //
// ./src/utilites/networkErrors/ValidationError.ts